import { type DetailState } from "./state";

export const initialState: DetailState = {
  delivery: null,
  ambassadors: [],
  reports: [],
  addresses: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isActing: false,
  actionError: "",
};
